import React from "react";
import { BsStarFill,BsStarHalf,BsStar } from "react-icons/bs";
function Rating({rating,numOfReviews}) {
  return (
    <span className="d-flex justify-content-lg-start">
      <span>
        {rating >=1 
        ? <BsStarFill className="rating" /> 
        : rating>=0.5 
        ? <BsStarHalf className="rating"/> 
        : <BsStar className="rating"/>}
      </span>
      <span>
        {rating >=2 
        ? <BsStarFill className="rating"/> 
        : rating>=1.5 
        ? <BsStarHalf className="rating"/> 
        : <BsStar className="rating"/>}
      </span>
      <span>
        {rating >=3 
        ? <BsStarFill className="rating"/> 
        : rating>=2.5 
        ? <BsStarHalf className="rating"/> 
        : <BsStar className="rating"/>}
      </span>
      <span>
        {rating >=4 
        ? <BsStarFill className="rating"/> 
        : rating>=3.5 
        ? <BsStarHalf className="rating"/> 
        : <BsStar/>}
      </span>
      <span>
        {rating >=5 
        ? <BsStarFill className="rating"/> 
        : rating>=4.5 
        ? <BsStarHalf className="rating"/> 
        : <BsStar className="rating"/>}
      </span>
    </span>
  );
}

export default Rating;
